/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import TruncateMarkup from 'react-truncate-markup';
import clsx from 'clsx';
import PropTypes from 'prop-types';

/**
 * A single message in an alert banner.
 */
const Message = ({
  isFirst,
  triggerCollapse,
  moreAlertText,
  content,
  label,
  truncate,
  url,
  position,
}) => {
  const classes = clsx(
    'alert-message',
    {
      'alert-message--truncated': !! truncate,
    },
  );

  const bannerRotationProgress = isFirst
    ? (
      <svg className="circle-progress" height="15" width="22">
        <circle
          cx="12"
          cy="6.5"
          r="6"
          stroke="#bda6d2"
          strokeWidth="1"
          fill="#fff"
        />
      </svg>
    ) : null;

  const collapseTriggerMessage = 0 < moreAlertText.length
    ? (
      <span
        id="more-alert-trigger"
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if ('Enter' === event.key) {
            triggerCollapse(event);
          }
        }}
        className="alert-banner__more-messages"
        onClick={(event) => {
          triggerCollapse(event);
        }}
      >
        {moreAlertText}
      </span>
    ) : null;

  return (
    <div
      className={classes}
      data-link-category="Alert Banner"
      data-module-type="alert banner"
    >
      <a
        className="alert-message__link"
        href={url}
        role="button"
        aria-label="banner link"
        onKeyDown={(e) => {
          e.target.click();
        }}
        data-link-type="alert-banner-link"
        data-link-label={label}
        data-link-position={position}
      />
      <div
        className="alert-message__inner"
      >
        <div className="alert-message__body">
          <div
            className="alert-banner__label-container"
            aria-hidden="true"
          >

            <span className="alert-banner__label">
              {label}
              {bannerRotationProgress}
            </span>

            {collapseTriggerMessage}
          </div>

          <TruncateMarkup
            lines={900 < window.screen.width ? 1 : 2}
            tokenize="words"
            ellipsis=" …"
          >
            <div className="alert-message__body__content">
              {content}
            </div>
          </TruncateMarkup>
          <div className="caret" />
        </div>
      </div>
    </div>
  );
};

Message.propTypes = {
  isFirst: PropTypes.bool,
  triggerCollapse: PropTypes.func,
  moreAlertText: PropTypes.string,
  content: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  truncate: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  url: PropTypes.string,
  position: PropTypes.number,
};

Message.defaultProps = {
  triggerCollapse: () => {},
  isFirst: false,
  moreAlertText: '',
  truncate: 1,
  url: '#',
  position: 1,
};

export default Message;
